import Product from '../product/product';
import PlacementInvoice from './placement-invoice';

export default class CustomProductInvoicePrice {
  product?: Product;

  placementInvoice?: PlacementInvoice;

  productionPrice?: string;

  placementPrice?: string;
}
